export const enum BUTTON_TYPE {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	// TERTIARY = 'tertiary',
	DANGER = 'danger',
	MENU = 'menu'
}

export const enum BUTTON_PRELOAD_DATA {
	NONE = 'none',
	OFF = 'off',
	HOVER = 'hover',
	TAP = 'tap'
}
